import React from 'react';
import styled from 'styled-components';
import style from './style';

export default styled(({ isLoading, color, flat, textColor, before, iconFloat, icon, inverted, to, href, ...rest }) => (
  <a href={href || to} {...rest} />
)).attrs({
  tabIndex: '0',
  className: 'btn btn-secondary',
})`
  ${style};
`;
